import { Task } from '@admiin-com/ds-graphql';
import { Dialog } from '@mui/material';
import { TaskReviewContent } from './TaskReviewContent';

export interface TaskReviewModalProps {
  open: boolean;
  onClose: () => void;
  task: Task;
  onSuccess?: () => void;
  onEdit?: () => void;
}

export const TaskReviewModal = ({
  open,
  onClose,
  task,
  onSuccess,
  onEdit,
}: TaskReviewModalProps) => {
  return (
    <Dialog open={open} onClose={onClose} fullScreen>
      <TaskReviewContent
        task={task}
        onClose={onClose}
        onSuccess={onSuccess}
        onEdit={onEdit}
      />
    </Dialog>
  );
};
